// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import PromoSubscriptionForm from './PromoSubscriptionForm'
import type { PropsType, DispatchPropsType } from './PromoSubscriptionForm'
import type { AppStateType } from '../../../../reducers/appstate'
import { changePlanAction, subscribeAction, applyPromoCode, clearPromoCode } from '../../../../actions/subscriptionActions'

type OwnPropsType = {
  subtype: 'monthly' | 'annual',
  subscriptionOfferCta: string,
  subscriptionOfferTitle: string,
  subscriptionOfferSubtitle: string,
  subscriptionOfferSubtext: string,
  isBlackFriday?: boolean,
  pageSlugForPromoEvent?: string,
  existingPromoCode?: string,
  isSocialPayButtonsFirst: boolean
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  return ({
    inProcess: state.subscriptionPurchase.inProcess,
    isSubscribed: !!state.user.isSubscribed,
    userLoaded: state.userLoaded,
    plan: state.subscriptionPurchase.plan,
    price: ownProps.isBlackFriday ? '29.99' : state.subscriptionText.price || '',
    error: state.subscriptionPurchase.error,
    subtype: ownProps.subtype,
    subscriptionOfferCta: ownProps.subscriptionOfferCta,
    subscriptionOfferTitle: ownProps.subscriptionOfferTitle,
    subscriptionOfferSubtitle: ownProps.subscriptionOfferSubtitle,
    subscriptionOfferSubtext: ownProps.subscriptionOfferSubtext,
    isBlackFriday: ownProps.isBlackFriday,
    pageSlugForPromoEvent: ownProps.pageSlugForPromoEvent,
    existingPromoCode: ownProps.existingPromoCode,
    isSocialPayButtonsFirst: ownProps.isSocialPayButtonsFirst,
    trialDays: (state.subscriptionText || {}).trialDays || 0
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    applyPromo: (promo: string, isMarketingLandingPage: boolean): void => dispatch(applyPromoCode(promo, false, isMarketingLandingPage)),
    clearPromo: (): void => dispatch(clearPromoCode()),
    setPlan: (plan: 'monthly' | 'annual'): void => dispatch(changePlanAction(plan)),
    subscribe: (stripeObj: any, cardNumberElement?: any, altPaymentEvent?: any): void => dispatch(subscribeAction(stripeObj, cardNumberElement, altPaymentEvent, true))
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, OwnPropsType, _, _, _, _>(mapStateToProps, mapDispatchToProps)(PromoSubscriptionForm)
